import React from 'react';
import { Alert, Button, Modal, Spinner } from 'react-bootstrap';
import { MdArrowBack, MdCheckCircle, MdWarning } from 'react-icons/md';
import './FaceValidationSkipModal.css';

export default function FaceValidationSkipModal({ show, saving, error, onConfirm, onHide }) {
    return <Modal show={show} onHide={saving ? () => {} : onHide} centered backdrop={saving ? 'static' : true} keyboard={!saving} className="candidate-skip-modal hidethis" dialogClassName="candidate-skip-dialog" aria-labelledby="candidate-skip-title">
        <Modal.Header closeButton={!saving} closeLabel="Fechar">
            <Modal.Title id="candidate-skip-title"><span className="candidate-skip-icon"><MdWarning aria-hidden="true" /></span>Continuar sem validação facial?</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <p>A validação facial não foi concluída. Ao continuar, você concorda que esta ação será registrada nos logs e poderá ser consultada pela organização.</p>
            <div className="candidate-skip-camera-notice">Mantenha a câmera compartilhada durante a avaliação.</div>
            {error && <Alert variant="danger" className="candidate-skip-error" role="alert">{error}</Alert>}
        </Modal.Body>
        <Modal.Footer>
            <Button type="button" variant="secondary" onClick={onHide} disabled={saving}><MdArrowBack aria-hidden="true" /> Voltar</Button>
            <Button type="button" variant="success" onClick={onConfirm} disabled={saving}>{saving ? <Spinner animation="border" size="sm" aria-hidden="true" /> : <MdCheckCircle aria-hidden="true" />}{saving ? 'Registrando...' : 'Concordo e desejo continuar'}</Button>
        </Modal.Footer>
    </Modal>;
}
